import { Outlet } from "react-router-dom";

import { PremiumOrgOnly } from "@/shared/components/PremiumOrgOnly";
import { NavigationSidebarProvider } from "@/shared/state/appSidebar";
import { CollaborationBarProvider } from "@/shared/state/collaborationBar";

import styles from "./AppLayout.module.css";
import { AppNavigation } from "./AppNavigation";
import { CollaborationBar } from "./CollaborationBar";

/**
 * Top-level layout component for the app.
 */
export function AppLayout() {
  return (
    <NavigationSidebarProvider>
      <CollaborationBarProvider>
        <div className={styles.appLayout}>
          <AppNavigation />
          <Outlet />
          <PremiumOrgOnly fallback={null}>
            <CollaborationBar />
          </PremiumOrgOnly>
        </div>
      </CollaborationBarProvider>
    </NavigationSidebarProvider>
  );
}
